import React from "react";

const FieldAliasManager = ({
  selectedFieldsMap,
  fieldAliases,
  aliasConflicts,
  onAliasChange,
}) => {
  // Separate selected fields into required (conflicts) and optional
  const required = [];
  const optional = [];

  Object.entries(selectedFieldsMap).forEach(([table, fields]) => {
    fields.forEach((field) => {
      const isConflict = aliasConflicts.includes(field.code);
      const alias = fieldAliases[field.code] || "";

      const entry = {
        ...field,
        table,
        alias,
        conflict: isConflict,
      };

      isConflict ? required.push(entry) : optional.push(entry);
    });
  });

  const hasFields = required.length + optional.length > 0;
  if (!hasFields) return null;

  return (
    <div className="mb-4 border rounded p-3 bg-white shadow-sm">
      <h5 className="fw-bold mb-3">📝 Field Aliases</h5>
      <p className="text-muted">
        All selected fields must have unique aliases. Fields in red must be
        renamed before continuing.
      </p>

      <div className="table-responsive">
        <table className="table table-sm table-bordered align-middle">
          <thead className="table-light">
            <tr>
              <th>Table</th>
              <th>Field</th>
              <th>Alias</th>
            </tr>
          </thead>
          <tbody>
            {required.length > 0 && (
              <>
                <tr className="table-danger">
                  <td colSpan="3" className="fw-bold">
                    ⚠️ Required: Conflicting Field Names
                  </td>
                </tr>
                {required.map((field) => (
                  <tr key={field.code}>
                    <td>{field.table}</td>
                    <td>{field.label}</td>
                    <td>
                      <input
                        type="text"
                        className="form-control form-control-sm is-invalid"
                        value={field.alias}
                        onChange={(e) =>
                          onAliasChange(field.code, e.target.value)
                        }
                      />
                      <div className="invalid-feedback">
                        Alias must be unique
                      </div>
                    </td>
                  </tr>
                ))}
              </>
            )}

            {optional.length > 0 && (
              <>
                <tr className="table-secondary">
                  <td colSpan="3" className="fw-bold">
                    Optional: Other Fields
                  </td>
                </tr>
                {optional.map((field) => (
                  <tr key={field.code}>
                    <td>{field.table}</td>
                    <td>{field.label}</td>
                    <td>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={field.alias}
                        onChange={(e) =>
                          onAliasChange(field.code, e.target.value)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FieldAliasManager;